<script setup lang="ts">
import type { ContentTermExam } from '~/models/Content/ContentTermExam'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { DateTime } from 'luxon'
import { SCHOOL_YEAR_START_WEEK } from '~/composables/useSchoolYear'
import AuCallout from '~/components/ui/AuCallout.vue'

const { exams } = defineProps<{ exams?: ContentTermExam }>()

const { t } = useI18n()
const currentWeek = DateTime.local().weekNumber

const placeholders = computed(() => ({
  title: currentWeek >= SCHOOL_YEAR_START_WEEK ? t('assign.upcoming.autumnTitle') : t('assign.upcoming.springTitle'),
  message: exams?.unavailableMessage || t('assign.upcoming.unknownDate'),
}))
</script>

<template>
  <section class="space-y-2">
    <h2
      class="text-2xl font-bold"
      v-text="placeholders.title"
    />
    <AuCallout variant="info" :title="placeholders.message" />
  </section>
</template>
